import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/_service/api.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/_service/auth.service';

@Component({
	selector: 'app-profilo',
	templateUrl: './profilo.component.html',
})
export class ProfiloComponent implements OnInit {
	constructor(
		private api: ApiService,
		private router: Router,
		private auth: AuthService,
	) {}

	jsonIn: any = {};
	error = '';

	user: any = {};
	indirizzi: any[] = [];

	ngOnInit() {
		this.user = this.auth.getUser();
		this.indirizzi = this.user.cliente?.indirizziSpedizione.filter((i) => !i.cancellato);
		console.log(this.user);
	}

	cambioPassword() {
		this.error = '';

		if (!this.jsonIn.oldPassword) {
			this.error += 'Compile OLD PASSWORD <br>';
		}

		if (!this.jsonIn.newPassword) {
			this.error += 'Compile NEW PASSWORD <br>';
		}

		if (!this.jsonIn.newPasswordRepeat) {
			this.error += 'Compile NEW PASSWORD REPEAT <br>';
		}

		if (this.jsonIn.newPassword !== this.jsonIn.newPasswordRepeat) {
			this.error += 'Confirm password does not match. <br>';
		}

		if (this.error) {
			return;
		}

		this.api.cambioPassword(this.jsonIn).subscribe((res: any) => {
			if (res.esito === 'KO' && res.descrizione === 'vecchia.password.non.corretta') {
				this.error += 'Old password does not match. <br>';
			} else if (res.esito === 'OK') {
				this.router.navigate(['/logout']);
			}
		});
	}
}
